import type { HelpFile } from '../../types/help'
import { ProfileTestIds } from '../../../testids/ProfileTestIds'

export const profileHelp: HelpFile = {
  docPage: '/docs/getting-started/profile',
  texts: {
    [ProfileTestIds.sectionBasicInfo]:
      'Profile information of the signed-in account — name, email, and authentication source.',
    [ProfileTestIds.sectionIamIdentity]:
      'The IAM identity linked to this account — click the link to open the full identity detail page.',
    [ProfileTestIds.cardTitleSessionInfo]:
      'Current login session — OAuth2 issuer and session expiry.',
    [ProfileTestIds.cardTitleRolesPermissions]:
      'Roles and permissions assigned to the signed-in account — used to evaluate access throughout the application.',
    [ProfileTestIds.linkIdentityDetails]: null,
    [ProfileTestIds.btnLogout]: null,
    [ProfileTestIds.btnTogglePermissions]:
      'Show or hide the full list of permissions resolved from the assigned roles.',
    [ProfileTestIds.inputFilterPermissions]:
      'Filter permissions by resource or action.',
    [ProfileTestIds.colResource]:
      'Resource (controller or domain object) the permission applies to.',
  },
}
